import React from "react";
import { StyleSheet, View, Image } from "react-native";

const BannerSkeleton = ({ height = 220, styles }) => {
  return (
    <View style={[style.banner, { height, ...styles }]}>
      <Image
        source={require("../../../assets/images/product-placeholder.webp")}
        style={{ height: 64, width: 64 }}
      />
    </View>
  );
};

const style = StyleSheet.create({
  banner: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f5f5f5",
    elevation: 1,
  },
  bannerImage: {
    height: 64,
    width: 64,
  },
});
export default BannerSkeleton;
